import { useState } from "react"


export default function CustomButtonSimple({ Icon, onClick, text, className, type, disabled, color  }: { Icon?: any, onClick?: any, text: string, className?: string, type?: "button" | "submit" | "reset", disabled?: boolean, color?: string }) {


    return (<button
    style={{
        backgroundColor: color
    }}
        disabled={disabled}
        type={type || 'button'}
        className={`text-sm flex items-center border rounded-md p-2 content-center cursor-pointer justify-center ${disabled ? 'bg-zinc-400 cursor-not-allowed' :
            `${color ? '' : 'bg-rodrimaq-red hover:border-rodrimaq-red hover:text-rodrimaq-red hover:bg-white'}   `} text-white max-h-12
                
            ${className}`}

        onClick={onClick}>
        {/* {Icon ? <Icon/> : null} */}

        {text ? <span className="p-2">{text}</span> : null}

    </button>)


}